module.exports = __webpack_public_path__ + "static/media/dinosaur(8).6987641e.PNG";